var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeams(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_9205",
    x: -1.423,
    y: -3,
    width: 28.242,
    height: 36.571,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-MS_Teams"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MS_Teams",
    "data-name": "MS Teams",
    clipPath: "url(#clip-MS_Teams)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "microsoft-teams-svgrepo-com",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9204",
    "data-name": "Path 9204",
    d: "M10.9,8.406h5.169a.883.883,0,0,1,.885.881v4.7a3.246,3.246,0,0,1-3.251,3.242h-.014a3.246,3.246,0,0,1-3.251-3.242V8.869a.461.461,0,0,1,.462-.461Zm3.5-.928A2.089,2.089,0,1,0,12.3,5.39a2.091,2.091,0,0,0,2.1,2.088Z",
    transform: "translate(4.042 0.558)",
    fill: "#2e78d5"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -1, -1)",
    filter: "url(#Path_9205)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9205-2",
    "data-name": "Path 9205",
    d: "M10.259,8.036A3.018,3.018,0,1,0,7.233,5.017a3.021,3.021,0,0,0,3.026,3.019Zm4.034.929H5.759a.873.873,0,0,0-.852.893v5.357a5.243,5.243,0,0,0,5.119,5.357,5.243,5.243,0,0,0,5.121-5.357V9.857A.873.873,0,0,0,14.294,8.964Z",
    transform: "translate(2.67 1)",
    fill: "#2e78d5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9206",
    "data-name": "Path 9206",
    d: "M10.493,6.875v7.512a.855.855,0,0,1-.852.851H5.316a5.648,5.648,0,0,1-.41-2.11V7.768a.872.872,0,0,1,.853-.892h4.732Z",
    transform: "translate(1.673 2.086)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9207",
    "data-name": "Path 9207",
    d: "M10.026,6.875v7.977a.858.858,0,0,1-.852.851H5.536a4.6,4.6,0,0,1-.382-.929,5.648,5.648,0,0,1-.246-1.644V7.766a.872.872,0,0,1,.852-.892h4.267Z",
    transform: "translate(1.674 2.081)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9208",
    "data-name": "Path 9208",
    d: "M10.026,6.875v7.047a.858.858,0,0,1-.852.851H5.154a5.648,5.648,0,0,1-.246-1.644V7.766a.872.872,0,0,1,.852-.892h4.267Z",
    transform: "translate(1.674 2.085)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9209",
    "data-name": "Path 9209",
    d: "M9.562,6.875v7.047a.858.858,0,0,1-.852.851H5.153a5.648,5.648,0,0,1-.246-1.644V7.766a.872.872,0,0,1,.852-.892h3.8Z",
    transform: "translate(1.673 2.085)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9210",
    "data-name": "Path 9210",
    d: "M9.768,5.451V6.914c-.079,0-.153.009-.233.009s-.153,0-.233-.009A3.023,3.023,0,0,1,6.593,4.6H8.916a.855.855,0,0,1,.852.849Z",
    transform: "translate(2.396 1.114)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9211",
    "data-name": "Path 9211",
    d: "M9.257,5.775v1A3.023,3.023,0,0,1,6.7,4.926H8.406A.855.855,0,0,1,9.257,5.775Z",
    transform: "translate(2.441 1.254)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9212",
    "data-name": "Path 9212",
    d: "M9.257,5.775v1A3.023,3.023,0,0,1,6.7,4.926H8.406A.855.855,0,0,1,9.257,5.775Z",
    transform: "translate(2.441 1.254)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9213",
    "data-name": "Path 9213",
    d: "M8.792,5.776V6.7A3.023,3.023,0,0,1,6.7,4.925H7.942A.855.855,0,0,1,8.792,5.776Z",
    transform: "translate(2.441 1.253)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9214",
    "data-name": "Path 9214",
    d: "M1.853,4.925h8.533a.852.852,0,0,1,.853.851v8.507a.851.851,0,0,1-.853.851H1.852A.851.851,0,0,1,1,14.283V5.776A.851.851,0,0,1,1.853,4.925Z",
    transform: "translate(0 1.256)",
    fill: "#2e78d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9215",
    "data-name": "Path 9215",
    d: "M7.5,7.464H5.8V12.1H4.71V7.464H3.01v-.9H7.5v.9Z",
    transform: "translate(0.863 1.954)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeams);
export default __webpack_public_path__ + "static/media/teams.242c6ea33725fc8de8be5e745eff44fd.svg";
export { ForwardRef as ReactComponent };